import { FormattedMessage } from 'react-intl';
import { Content } from '../components/Content';
import { PageTitle } from '../components/PageTitle';
import { useIndexedDB } from 'react-indexed-db-hook';
import { Fragment, useEffect, useState } from 'react';
import { DbDraft } from '../type';
import { Empty } from '../components/Empty';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { ListTeams } from '../components/ListTeams';
import { decompress } from '../helpers/compress';

export const List = () => {
  const navigate = useNavigate();
  const { getAll } = useIndexedDB('draftList');
  const [list, setList] = useState<DbDraft[]>([]);

  useEffect(() => {
    getAll<DbDraft>()
      .then((data) => {
        setList(data.reverse());
      })
      .catch((err: unknown) => {
        console.error(err);
      });
  }, []);

  return (
    <Content justify="start">
      <PageTitle>
        <FormattedMessage id="draftList" />
      </PageTitle>
      {list.length === 0 && (
        <Empty
          icon="draft"
          title="listEmptyTitle"
          description="listEmptyDescription"
        >
          <Button
            color={'yellow'}
            onClick={() => {
              navigate('/draft/create');
            }}
          >
            <FormattedMessage id="create" />
          </Button>
        </Empty>
      )}
      {list.length > 0 &&
        list.map((l) => {
          const draft = decompress(l.data);
          if (!draft) return;
          return (
            <Fragment key={l.data}>
              <ListTeams draft={draft} token={l.data} />
            </Fragment>
          );
        })}
    </Content>
  );
};
